module.exports = __webpack_public_path__ + "img/kx5200-6.eeefcb01.png";